import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UserStore} from '../../authentication/state/user.store';
import {PasswordChange} from '../models/password-change';
import {Observable} from 'rxjs';
import {API_PATH} from '../../shared/constants';
import {NotificationSettings} from '../models/notification-settings';
import {BankPolicyResponse} from '../models/bank-policy-group';
import {PersonBankAccountResponse} from '../models/person-bank-account';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient, private userStore: UserStore) { }

  changePassword(password: PasswordChange): Observable<any> {
    const user = this.userStore.getValue();
    const parameters = new Map<string, string>();

    parameters.set('person_id', user?.person_id.toString());
    parameters.set('current_password', password?.currentPassword);
    parameters.set('new_password', password?.newPassword);

    return this.runCommandNew('updatePassword', parameters);
  }

  getNotificationSettings(): Observable<NotificationSettings[]> {
    const user = this.userStore.getValue();
    const parameters = new Map<string, string>();
    parameters.set('person_id', user?.person_id.toString());

    return this.runCommandNew('getNotification_settings', parameters);
  }

  updateNotificationSettings(settings: string): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('NotificationSettings', settings);

    return this.runCommandNew('UpdateUserNotificationSettings', parameters);
  }

  getBankPolicy(person_id: number = 0): Observable<BankPolicyResponse[]> {
    const user = this.userStore.getValue();
    if(person_id === 0){
      person_id = user?.person_id;
    }
    const parameters = new Map<string, string>();
    parameters.set('person_id', person_id.toString());

    return this.runCommandNew('getPerson_bank_policy_rel', parameters);
  }

  getBanks(): Observable<any> {
    const parameters = new Map<string, string>();
    return this.runCommandNew('getBanks', parameters);
  }

  getPersonBankAccounts(person_id: number): Observable<PersonBankAccountResponse[]> {
    //const user = this.userStore.getValue();
    const parameters = new Map<string, string>();
    parameters.set('person_id', person_id.toString());

    return this.runCommandNew('getPerson_bank', parameters);
  }

  savePersonBank(json: string, person_id: number): Observable<any> {
    //const user = this.userStore.getValue();
    const parameters = new Map<string, string>();
    parameters.set('person_id', person_id.toString());
    parameters.set('BankingDetails_JSON', json);

    return this.runCommandNew('savePerson_bank', parameters);
  }

  savePolicyNewBank(bank_id: number, policy_id: string): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('person_bank_id', bank_id.toString());
    parameters.set('policy_id', policy_id.toString());

    return this.runCommandNew('savePerson_bank_policy_rel', parameters);
  }

  savePolicyBankTransfer(from_bank_id: number, to_bank_id: number): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('person_bank_id_from', from_bank_id?.toString());
    parameters.set('person_bank_id_to', to_bank_id?.toString());

    return this.runCommandNew('savePerson_bank_transfer', parameters);
  }

  runCommandNew(command: string, parameters: Map<string, string>, multiple: boolean = false): Observable<any> {
    const parametersObject = {};
    for (const [key, value] of parameters) {
      parametersObject[key] = value;
    }

    const requestBody: any = {
      Parameters: parametersObject,
      Command: command,
      Dataset: multiple
    };

    return this.http.post(`${API_PATH.RUN_NEW_COMMAND}`, requestBody);
  }
}
